import { InputDateGroup } from "@/components/ui/input-date";

export function DateRangeInputs({ currentExport, data, setData }) {
  if (
    currentExport == "sot" ||
    currentExport == "prt reporting" ||
    currentExport == "rrt reporting" ||
    currentExport == "part usage"
  ) {
    return (
      <>
        <InputDateGroup
          label="From"
          value={data.date_from ? data.date_from.split("T")[0] : ""}
          onChange={(date) => {
            setData({ ...data, date_from: date ? date + "T00:00:00" : null });
          }}
        />
        <InputDateGroup
          label="To"
          value={data.date_to ? data.date_to.split("T")[0] : ""}
          onChange={(date) => {
            setData({ ...data, date_to: date ? date + "T23:59:59" : null });
          }}
        />
      </>
    );
  }
  return null;
}
